var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fulfillment-reasons" }, [
    _c("h3", { staticClass: "title" }, [_vm._v("\n    Reason\n  ")]),
    _vm._v(" "),
    _c("ul", { staticClass: "reasons-list" }, [
      _c("li", { staticClass: "reason-item" }, [
        _vm._v("\n      " + _vm._s(_vm.reason) + "\n    "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }